import { data } from 'jquery';
import React, { useState, useEffect } from "react";
import { Table, Container, Input, Row, Col, Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import './ProposalStyle.css';
import "./Reports.css";
import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfMake from "pdfmake/build/pdfmake";
import CreateTableComponent from "../../share/CreateTableComponent";
import { NumberWithCommmas2 } from "../../share/NumberWithCommmas2";
pdfMake.vfs = pdfFonts.pdfMake.vfs;



export function Report55Component() {


    const [thYearSelected, setThYearSelected] = React.useState(new Date().getFullYear() + 543)



    const [Re55data, setRe55data] = useState([]);
    const [openModalForm, setOpenModalForm] = useState(false);
    const [Re55detail, setRe55detail] = useState([]);
    const [status, setStatus] = useState("13");
    const [R55detailfilter, setR55detailfilter] = useState([]);

    async function getR55() {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        const res = await fetch("/api/Support/getR55", {
            method: 'POST',
            body: formData
        })
        const Re55data = await res.json()

        setRe55data(Re55data.dataenum)
        console.log(Re55data)
    }

    const [Re55yeardata, setRe55yeardata] = React.useState([]);
    async function getR55year() {
        const res = await fetch("/api/Support/getyear55")
        const Re55yeardata = await res.json()
        setRe55yeardata(Re55yeardata.dataenum)
        console.log(Re55yeardata)
    }
    var yy = (thYearSelected - 1);
    React.useEffect(() => {
        getR55()
        getR55year()
    }, [thYearSelected]);

  


   

    async function getR55detail(value, type) {
        const formData = new FormData();
        // console.log("thYearSelected",typeof thYearSelected);
        formData.append("thYear", thYearSelected);
        formData.append("status", String(type));
        // console.log("status",status);
        console.log("value", value);
        console.log("type", type);
        const res61 = await fetch("/api/Support/getR55detail", {
            method: 'POST',
            body: formData
        })
        const Re55data = await res61.json()
        // setRe61detail(Re61data.dataenum);
        setR55detailfilter(Re55data.dataenum.filter(
            (item) => item.supportDetail === value
        ))
        console.log(Re55data);
        modalToggleExtendCourse();
    }

    const modalToggleExtendCourse = () => {
        // getR55detail()
        setOpenModalForm(!openModalForm);
        // console.log("idmodal", value);
    }

    const COLUMNSTRAIN = [
        {
            Header: "ลำดับ",
            accessor: (_row, i) => i + 1,
        },
        {
            Header: "ชื่อผู้ได้รับเงินช่วยเหลือหรืออุดหนุน",
            accessor: "supportName",
        },
        {
            Header: "เลขที่คำขอ",
            accessor: "supportNo",
        },
        {
            Header: "จำนวนคน",
            accessor: "personTotal",
            Cell: ({ value }) => {
                return (
                    <>
                        {NumberWithCommmas2(value)}

                    </>
                )

            }
        },
        {
            Header: "จำนวนเงินที่จ่ายเงินอุดหนุนแล้ว (บาท)",
            accessor: "amount",
            Cell: ({ value }) => {
                return (
                    <>
                        {NumberWithCommmas2(value)}

                    </>
                )

            }
        },

    ]

    return (
        <Container>
            <div>
                <div style={{ display: 'flex', paddingBottom: '20px', justifyContent: 'center' }}>

                    <h3 className='text-center' style={{ lineHeight: 'inherit' }}> ปีงบประมาณ พ.ศ.</h3>
                    <Input
                        style={{ borderColor: "#130558", width: "10%", paddingTop: '0px', fontSize: '1.75rem' }}
                        id="othYear"
                        name="othYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >

                        {Re55yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>

                </div>
                <Row>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn1" href={`api/Support/xlsxR55?thYear=${thYearSelected}`} download>EXCEL</Button>
                        <Button className="btn1" href={`api/SupportReports/excelR55detail?thYear=${thYearSelected}&status=${status}`} download>EXCEL(Detail)</Button>
                        <Button className="btn2" href={`api/Support/pdfR55?thYear=${thYearSelected}`} download>PDF</Button>
                    </Col>
                </Row>
                <div className="outer-wrapper">
                    <div className="table-wrapper">
                        <Table className="styled-table" bordered striped hover>
                            <thead>
                                <tr>
                                    <th rowSpan="3">
                                        ลำดับ
                                    </th>
                                    <th rowSpan="3" className='text-center'>
                                        รายการ
                                    </th>
                                    <th colSpan="36" className=' text-center'>
                                        อนุมัติเงินอุดหนุน
                                    </th>
                                    <th colSpan="3" className=' text-center'>

                                    </th>
                                </tr>
                                <tr>
                                    <th colSpan="3" className='text-center'>
                                        ตุลาคม {yy}
                                    </th>
                                    <th colSpan="3" className='text-center'>
                                        พฤศจิกายน {yy}
                                    </th>
                                    <th colSpan="3" className='text-center'>
                                        ธันวาคม {yy}
                                    </th>
                                    <th colSpan="3" className='text-center'>
                                        มกราคม {thYearSelected}
                                    </th>
                                    <th colSpan="3" className='text-center'>
                                        กุมภาพันธ์ {thYearSelected}
                                    </th>
                                    <th colSpan="3" className='text-center'>
                                        มีนาคม {thYearSelected}
                                    </th>
                                    <th colSpan="3" className='text-center'>
                                        เมษายน {thYearSelected}
                                    </th>
                                    <th colSpan="3" className='text-center'>
                                        พฤษภาคม {thYearSelected}
                                    </th>
                                    <th colSpan="3" className='text-center'>
                                        มิถุนายน {thYearSelected}
                                    </th>
                                    <th colSpan="3" className='text-center'>
                                        กรกฎาคม {thYearSelected}
                                    </th>
                                    <th colSpan="3" className='text-center'>
                                        สิงหาคม {thYearSelected}
                                    </th>
                                    <th colSpan="3" className='text-center'>
                                        กันยายน {thYearSelected}
                                    </th>
                                    <th colSpan="3" className='text-center'>
                                        รวม
                                    </th>
                                </tr>
                                <tr>
                                    <th className='text-center'>
                                        (แห่ง)
                                    </th>
                                    <th className='text-center'>
                                        คน
                                    </th>
                                    <th className='text-center'>
                                        (บาท)
                                    </th>
                                    <th className='text-center'>
                                        (แห่ง)
                                    </th>
                                    <th className='text-center'>
                                        คน
                                    </th>
                                    <th className='text-center'>
                                        (บาท)
                                    </th>
                                    <th className='text-center'>
                                        (แห่ง)
                                    </th>
                                    <th className='text-center'>
                                        คน
                                    </th>
                                    <th className='text-center'>
                                        (บาท)
                                    </th>
                                    <th className='text-center'>
                                        (แห่ง)
                                    </th>
                                    <th className='text-center'>
                                        คน
                                    </th>
                                    <th className='text-center'>
                                        (บาท)
                                    </th>
                                    <th className='text-center'>
                                        (แห่ง)
                                    </th>
                                    <th className='text-center'>
                                        คน
                                    </th>
                                    <th className='text-center'>
                                        (บาท)
                                    </th>
                                    <th className='text-center'>
                                        (แห่ง)
                                    </th>
                                    <th className='text-center'>
                                        คน
                                    </th>
                                    <th className='text-center'>
                                        (บาท)
                                    </th>
                                    <th className='text-center'>
                                        (แห่ง)
                                    </th>
                                    <th className='text-center'>
                                        คน
                                    </th>
                                    <th className='text-center'>
                                        (บาท)
                                    </th>
                                    <th className='text-center'>
                                        (แห่ง)
                                    </th>
                                    <th className='text-center'>
                                        คน
                                    </th>
                                    <th className='text-center'>
                                        (บาท)
                                    </th>
                                    <th className='text-center'>
                                        (แห่ง)
                                    </th>
                                    <th className='text-center'>
                                        คน
                                    </th>
                                    <th className='text-center'>
                                        (บาท)
                                    </th>
                                    <th className='text-center'>
                                        (แห่ง)
                                    </th>
                                    <th className='text-center'>
                                        คน
                                    </th>
                                    <th className='text-center'>
                                        (บาท)
                                    </th>
                                    <th className='text-center'>
                                        (แห่ง)
                                    </th>
                                    <th className='text-center'>
                                        คน
                                    </th>
                                    <th className='text-center'>
                                        (บาท)
                                    </th>
                                    <th className='text-center'>
                                        (แห่ง)
                                    </th>
                                    <th className='text-center'>
                                        คน
                                    </th>
                                    <th className='text-center'>
                                        (บาท)
                                    </th>
                                    <th className='text-center'>
                                        (แห่ง)
                                    </th>
                                    <th className='text-center'>
                                        คน
                                    </th>
                                    <th className='text-center'>
                                        (บาท)
                                    </th>
                                </tr>

                            </thead>

                            <tbody>

                                {Re55data.length > 0 && Re55data.map((item, i) => (
                                    <tr>
                                        <td className='text-center' >
                                            {i + 1}
                                        </td>
                                        <td className='text-start'>
                                            {item.supportDetail}
                                        </td>
                                        <td className='text-end'>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.supportDetail}
                                                onClick={(e) => {
                                                    getR55detail(e.target.id, "9")
                                                }}>{Number(item.oct1)}</p>
                                            {/* {item.oct1} */}
                                        </td>
                                        <td className='text-end'>
                                            {item.oct3}
                                        </td>
                                        <td className='text-end'>
                                            {item.oct2}
                                        </td>
                                        <td className='text-end'>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.supportDetail}
                                                onClick={(e) => {
                                                    getR55detail(e.target.id, "10")
                                                }}>{Number(item.nov1)}</p>
                                            {/* {item.nov1} */}
                                        </td>
                                        <td className='text-end'>
                                            {item.nov3}
                                        </td>
                                        <td className='text-end'>
                                            {item.nov2}
                                        </td>
                                        <td className='text-end'>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.supportDetail}
                                                onClick={(e) => {
                                                    getR55detail(e.target.id, "11")
                                                }}>{Number(item.dec1)}</p>
                                            {/* {item.dec1} */}
                                        </td>
                                        <td className='text-end'>
                                            {item.dec3}
                                        </td>
                                        <td className='text-end'>
                                            {item.dec2}
                                        </td>
                                        <td className='text-end'>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.supportDetail}
                                                onClick={(e) => {
                                                    getR55detail(e.target.id, "0")
                                                }}>{Number(item.jan1)}</p>
                                            {/* {item.jan1} */}
                                        </td>
                                        <td className='text-end'>
                                            {item.jan3}
                                        </td>
                                        <td className='text-end'>
                                            {item.jan2}
                                        </td>
                                        <td className='text-end'>
                                            <p className="border-0 text-black btn btn-outline-light" type="button" id={item.supportDetail}
                                                onClick={(e) => {
                                                    getR55detail(e.target.id, "1")
                                                }}>{Number(item.feb1)}</p>
                                            {/* {item.feb1} */}
                                        </td>
                                        <td className='text-end'>
                                            {item.feb3}
                                        </td>
                                        <td className='text-end'>
                                            {item.feb2}
                                        </td>
                                        <td className='text-end'>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.supportDetail}
                                                onClick={(e) => {
                                                    getR55detail(e.target.id, "2")
                                                }}>{Number(item.march1)}</p>
                                            {/* {item.march1} */}
                                        </td>
                                        <td className='text-end'>
                                            {item.march3}
                                        </td>
                                        <td className='text-end'>
                                            {item.march2}
                                        </td>
                                        <td className='text-end'>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.supportDetail}
                                                onClick={(e) => {
                                                    getR55detail(e.target.id, "3")
                                                }}>{Number(item.apr1)}</p>
                                            {/* {item.apr1} */}
                                        </td>
                                        <td className='text-end'>
                                            {item.apr3}
                                        </td>
                                        <td className='text-end'>
                                            {item.apr2}
                                        </td>
                                        <td className='text-end'>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.supportDetail}
                                                onClick={(e) => {
                                                    getR55detail(e.target.id, "4")
                                                }}>{Number(item.may1)}</p>
                                            {/* {item.may1} */}
                                        </td>
                                        <td className='text-end'>
                                            {item.may3}
                                        </td>
                                        <td className='text-end'>
                                            {item.may2}
                                        </td>
                                        <td className='text-end'>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.supportDetail}
                                                onClick={(e) => {
                                                    getR55detail(e.target.id, "5")
                                                }}>{Number(item.jun1)}</p>
                                            {/* {item.jun1} */}
                                        </td>
                                        <td className='text-end'>
                                            {item.jun3}
                                        </td>
                                        <td className='text-end'>
                                            {item.jun2}
                                        </td>
                                        <td className='text-end'>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.supportDetail}
                                                onClick={(e) => {
                                                    getR55detail(e.target.id, "6")
                                                }}>{Number(item.jul1)}</p>
                                            {/* {item.jul1} */}
                                        </td>
                                        <td className='text-end'>
                                            {item.jul3}
                                        </td>
                                        <td className='text-end'>
                                            {item.jul2}
                                        </td>
                                        <td className='text-end'>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.supportDetail}
                                                onClick={(e) => {
                                                    getR55detail(e.target.id, "7")
                                                }}>{Number(item.aug1)}</p>
                                            {/* {item.aug1} */}
                                        </td>
                                        <td className='text-end'>
                                            {item.aug3}
                                        </td>
                                        <td className='text-end'>
                                            {item.aug2}
                                        </td>
                                        <td className='text-end'>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.supportDetail}
                                                onClick={(e) => {
                                                    getR55detail(e.target.id, "8")
                                                }}>{Number(item.sept1)}</p>
                                            {/* {item.sept1} */}
                                        </td>
                                        <td className='text-end'>
                                            {item.sept3}
                                        </td>
                                        <td className='text-end'>
                                            {item.sept2}
                                        </td>
                                        <td className='text-end'>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.supportDetail}
                                                onClick={(e) => {
                                                    getR55detail(e.target.id, "12")
                                                }}>{Number(item.sum1)}</p> 
                                            {/* {item.sum1} */}
                                        </td>
                                        <td className='text-end'>
                                            {item.sum3}
                                        </td>
                                        <td className='text-end'>
                                            {item.sum2}
                                        </td>

                                    </tr>
                                )) || <tr><td colSpan="41" rowSpan="6" className='text-center'>No Data</td></tr>}


                                

                            </tbody>

                        </Table>
                    </div>
                </div>
            </div>

            <Modal

                isOpen={openModalForm}
                toggle={modalToggleExtendCourse}
                // style={{ maxWidth: "600px", width: "100%" }}
                centered
                scrollable
                backdrop={'static'}
                keyboard={false}
                size="xl"

                className="modal-bordered"
            >
                <ModalHeader toggle={modalToggleExtendCourse} className="styled-modal text-center">
                    รายละเอียดข้อมูล
                </ModalHeader>
                <ModalBody >
                    <CreateTableComponent column={COLUMNSTRAIN} dataInput={R55detailfilter} showEntrie={true} showPage={true} />
                </ModalBody>
            </Modal>

        </Container>


    )
}